// Model.js
// -----------------------
// @module Case
define("Dev.ShoppingActions.ShoppingActionsModule.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/ShoppingActionsModule/SuiteScript2/ShoppingActionsModule.Service.ss"
            ),
            true
        )
});
});
